import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { withRouter } from 'react-router-dom';


import DomainingImage from '../../assets/img/rewamp/footer/domaining.png';
import IcaImage from '../../assets/img/rewamp/footer/ica.png';
import LogoDarkImage from '../../assets/img/rewamp/footer/logo-dark.svg';
import XImage from '../../assets/img/rewamp/footer/x.svg';
import FacebookImage from '../../assets/img/rewamp/footer/facebook.svg';
import LinkedInImage from '../../assets/img/rewamp/footer/linkedin.svg';
import YoutubeImage from '../../assets/img/rewamp/footer/youtube.svg';

export const RewampedFooter: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  let history = useHistory();
  const [show, setShow] = useState(false);

  useEffect(() => {
    var aScript = document.createElement('script');
    aScript.type = 'text/javascript';
    aScript.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    aScript.async = true;
    document.head.appendChild(aScript);
    aScript.onload = () => {
      setShow(true);
    };
  }, []);

  return (
    <div className="rewamped-footer">
      <div className="sec1">
        <div className="trust">WHERE TRUST MEETS INDUSTRY RECOGNITION</div>
        {show && <div className="tp-logo">
          <div
            className="trustpilot-widget sec-tp"
            data-locale="en-US"
            data-template-id="53aa8807dec7e10d38f59f32"
            data-businessunit-id="5e4179e55dd2990001312959"
            data-style-height="110px"
            data-theme="dark"
          >
            <a href="https://www.trustpilot.com/review/saw.com"
              target="_blank" rel="noopener">Trustpilot</a>
          </div>
        </div>}
        <div className="ica">
          <img
            src={IcaImage}
            alt=""
            height="74px"
          />
        </div>
        <div className="domaining">
          <img
            height="74px"
            src={DomainingImage}
            alt="" onClick={() => { window.open("https://www.domaining.com/feed/saw/", "_blank", "noopener,noreferrer") }}
          />
        </div>
      </div>
      <div className="sec2">
        <div className="col1">
          <img
            src={LogoDarkImage}
            alt=""
            height="50px"
          />
          <div className='copyright'>© 2026 Saw.com</div>
        </div>
        <div className="col2">
          <div><a href="https://saw.com/buy-domain" target="_blank"
            rel="noopener noreferrer">Buy a Domain</a></div>
          <div><a href="https://saw.com/sell" target="_blank"
            rel="noopener noreferrer">Sell a Domain</a></div>
          <div><a href="https://saw.com/buy-appraisals" target="_blank"
            rel="noopener noreferrer">Domain Appraisals</a></div>
          <div><a href="https://saw.com/portfolio-management" target="_blank"
            rel="noopener noreferrer">Portfolio Management</a></div>
          <div><a href="https://saw.com/outbound-brokerage" target="_blank"
            rel="noopener noreferrer">Outbound Brokerage</a></div>
          <div><a href="https://saw.com/domain-brand-protection" target="_blank"
            rel="noopener noreferrer">Defensive Registration</a></div>
        </div>

        <div className="col3">
          <div><a href="https://saw.com/adultblock" target="_blank"
            rel="noopener noreferrer">Adult Block</a></div>
          <div><a href="https://saw.com/affiliate-program" target="_blank"
            rel="noopener noreferrer">Affiliate Program</a></div>
          <div><a href="https://saw.com/upgrade" target="_blank"
            rel="noopener noreferrer">Resources</a></div>
          <div><a href="https://saw.com/faq" target="_blank"
            rel="noopener noreferrer">FAQ</a></div>
          <div><a href="https://saw.com/blog" target="_blank"
            rel="noopener noreferrer">Blog</a></div>
          <div><a href="https://saw.com/podcast" target="_blank"
            rel="noopener noreferrer">Podcast</a></div>
        </div>

        <div className="col4">
          <div><a href="https://saw.com/about" target="_blank"
            rel="noopener noreferrer">About</a></div>
          <div><a href="https://saw.com/contact-us" target="_blank"
            rel="noopener noreferrer">Contact Us</a></div>
          <div><a href="https://saw.com/privacy-policy" target="_blank"
            rel="noopener noreferrer">Privacy Policy</a></div>
          <div><a href="https://saw.com/terms-of-service" target="_blank"
            rel="noopener noreferrer">Terms of Service</a></div>
        </div>
        <div className="col5">
          <div className='top'>
            <div className='qn'>Questions?</div>
            <div className='number' onClick={() => {
              window.location.href = "tel:+17812819475";
            }}>Call us at +1 (781) 281-9475</div>
          </div>
          <div className="socials">
            <img src={XImage} alt="" onClick={() => window.open('https://x.com/sawsells')} />
            <img src={LinkedInImage} alt="" onClick={() => window.open('https://www.linkedin.com/company/saw-com/')} />
            <img src={YoutubeImage} alt="" onClick={() => window.open('https://www.youtube.com/channel/UCPmoATtesikiA5XCIBu4URw')} />
            <img src={FacebookImage} alt="" onClick={() => window.open('https://www.facebook.com/sawcom/')} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(RewampedFooter);
